import { Title } from '@components/v2/title'
import { ListOptions } from './list-options'
import styles from './styles.module.scss'
import { TextBase } from '@components/v2/text-base'
import { questions } from './list-options/options'
import { BoxedContent } from '@components/boxed-content'

export const SectionQuestionsAboutFreeMarket = () => {
  return (
    <BoxedContent>
      <div className={styles.container}>
        <Title className="text-center tracking-wide" level="h2">
          <div>
            Perguntas frequentes sobre o<br />
            <span className="text-orange"> Mercado Livre de Energia</span>
          </div>
        </Title>
        <div className="py-10 lg:py-20 lg:self-start">
          <ListOptions data={questions} />
        </div>
      </div>
      <div className={styles.sectionFooter}>
        <TextBase className={styles.footerHeading}>Aviso Legal</TextBase>
        <br />
        <TextBase className={styles.footerDescription}>
          As informações aqui apresentadas são essencialmente didáticas e gerais
          sobre o que é o Ambiente de Contratação Livre (ACL), mais conhecido
          apenas como mercado livre. Para aspectos regulatórios sobre as
          condições de negociação, regras de elegibilidade e responsabilidades
          jurídicas da contratação de energia elétrica no mercado livre de
          energia no Brasil, consulte um especialista. O Grupo Portal Solar não
          se responsabiliza por decisões comerciais tomadas com base nessas
          informações.
        </TextBase>
      </div>
    </BoxedContent>
  )
}
